import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'Do I need to be flexible to start?',
  a: 'No. This is designed specifically for people who are currently stiff and in pain.'
}, {
  q: 'Can I do this in a suit or work clothes?',
  a: 'Yes. There is no sweating, stretching on the floor, or lunging involved in the core Matrix.'
}, {
  q: "How soon will I feel the 'lightning' stop?",
  a: "Many users feel 'nerve relief' within the first 2 minutes of the Nerve-Glide sequence."
}, {
  q: 'Is this safe for a herniated disc?',
  a: 'The decompression moves are designed to reduce pressure on discs, but always consult your doctor first.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-dark-panel py-24 border-b border-dark-lighter" data-id="element-32">
      <div className="max-w-3xl mx-auto px-6" data-id="element-33">
        <FadeIn data-id="element-34">
          <h2 className="font-display text-4xl md:text-5xl font-bold uppercase mb-12 text-center" data-id="element-35">
            Frequently Asked <span className="text-cyan-accent" data-id="element-36">Questions</span>
          </h2>

          <div className="space-y-4" data-id="element-37">
            {faqs.map((faq, index) => <div key={index} className="bg-dark border border-dark-lighter overflow-hidden" data-id="element-38">
                <button className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-39">
                  <span className="font-display text-xl uppercase text-white pr-4" data-id="element-40">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-cyan-accent transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-41" />
                </button>
                <AnimatePresence data-id="element-42">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-43">
                      <div className="px-6 pb-6 text-gray-400 text-lg border-t border-dark-lighter pt-4" data-id="element-44">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}